export default __webpack_public_path__ + "static/media/Opposites02_00.7867fb96.png";